module.exports = __webpack_public_path__ + "img/login-theme4.3fd2b3cd.svg";